import { createMemoryHistory, createRouter as createTanStackRouter } from '@tanstack/react-router';
import { setupRouterSsrQueryIntegration } from '@tanstack/react-router-ssr-query';
import UmbrellaErrorRouteComponent from '#/_packages/umbrella/features/error-handling/components/umbrella-error-component.tsx';
import { getContext } from '#/_packages/umbrella/integrations/tanstack-query/root-provider.tsx';
import GenericNotFoundComponent from '#/_packages/umbrella/features/error-handling/components/not-found.tsx';
import { routeTree } from './routeTree.gen';

export function getRouter() {
    const context = getContext();

    const router = createTanStackRouter({
        routeTree,
        context,
        scrollRestoration: true,
        defaultPreload: 'intent',
        defaultPreloadStaleTime: 0,
        defaultErrorComponent: UmbrellaErrorRouteComponent,
        defaultNotFoundComponent: GenericNotFoundComponent,
    });

    setupRouterSsrQueryIntegration({ router, queryClient: context.queryClient });

    return router;
}

export function getPreviewRouter() {
    const context = getContext();

    const router = createTanStackRouter({
        routeTree,
        context,
        history: createMemoryHistory({
            initialEntries: ['/umbraco/block-preview'],
        }),
        scrollRestoration: true,
        defaultPreload: 'intent',
        defaultPreloadStaleTime: 0,
        defaultErrorComponent: UmbrellaErrorRouteComponent,
        defaultNotFoundComponent: GenericNotFoundComponent,
    });

    setupRouterSsrQueryIntegration({ router, queryClient: context.queryClient });

    return router;
}

declare module '@tanstack/react-router' {
    interface Register {
        router: ReturnType<typeof getRouter>;
    }
}
